import React from "react";

function DeleteIcon() {
  return (
    <span className="anticon anticon-closeCricle">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 20 22"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fill="currentColor" transform="translate(-534 -301)">
            <g transform="translate(474 131)">
              <g transform="translate(60 163)">
                <path d="M13 7a2 2 0 012 2v1h3a2 2 0 012 2v2a2 2 0 01-2 2h-.081L17 27a2 2 0 01-2 2H5c-1.105 0-2-.895-1.997-1.917L2.08 16H2a2 2 0 01-2-2v-2a2 2 0 012-2h3V9a2 2 0 012-2h6zm2.913 9H4.086L5 27h10l.003-.083.91-10.917zM18 12H2v2h16v-2zm-5-3H7v1h6V9z"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

export default DeleteIcon;
